import { LitElement, html, svg } from 'lit';

export class IconBuilding24 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24"><title>Boligblokk</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 23V1h18v22"></path><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M9 23v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4M1 23h22M7 5h3M7 9h10M14 13h3M7 13h3M14 5h3"></path></svg>`; }
}
if (!customElements.get('f-icon-building24', IconBuilding24)) {
  customElements.define('f-icon-building24', IconBuilding24);
}